import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      stroke="#000"
      strokeWidth={0.8}
      d="M15.677 12.323c.928.928 2.245 1.408 4.05 1.677-1.805.269-3.122.75-4.05 1.677-.928.928-1.408 2.245-1.677 4.05-.269-1.805-.75-3.122-1.677-4.05-.928-.928-2.245-1.408-4.05-1.677 1.805-.269 3.123-.75 4.05-1.677.928-.928 1.408-2.245 1.677-4.05.269 1.806.75 3.123 1.677 4.05Z"
    />
  </Svg>
)
export default SvgComponent
